import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { statusOptions, activeStatusVals } from './statusOptions';

const StatusFilter = ({ value, onChange }) => {
  const handleChange = val => onChange(
    value.includes(val)
      ? value.filter(v => v !== val)
      : [...value, val]
  );

  const handleResetClick = evt => {
    evt.preventDefault();
    onChange([]);
  }

  const classes = val => classNames('z-form-choice-button', 'small', value.includes(val) && 'selected');

  return (
    <div className="d-flex align-items-center">
      <span className="text-light-alt">Status:</span>
      {statusOptions.map(val => (
        <button
          type="button"
          key={val}
          className={classes(val)}
          onClick={() => handleChange(val)}
        >{val}</button>
      ))}
      <a className="reset-link fw-bold text-sm ms-3" href="#" onClick={handleResetClick}>reset</a>
    </div>
  );
};

StatusFilter.propTypes = {
  value: PropTypes.arrayOf(PropTypes.oneOf(statusOptions)),
  onChange: PropTypes.func,
};

export default StatusFilter;
